/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { Form, InputGroup } from 'react-bootstrap';

import PhoneInput from './phone-input';
import parsePhoneNumber from 'libphonenumber-js';
import './phone-input/styles/bootstrap.css';

import * as S from '../../styles';

export interface IPhoneNumberInputProps {
    id: string;
    fontScale?: number;

    label?: string;
    value?: string;
    errorText?: string;
    required?: boolean;
    readOnly?: boolean;
    placeholder?: string;
    labelColor?: string;
    hasError?: boolean;
    onCompChange?(id: string, payload: any): void;
}

export const PhoneNumberInput = ({
    id,
    fontScale,

    label,
    hasError,
    errorText,
    value,
    required,
    placeholder,
    onCompChange,
    labelColor,
}: IPhoneNumberInputProps) => {
    const [valid, setValid] = useState<Boolean>(true);
    const [textValue, setTextValue] = useState(value ?? '');
    const [errorData, setErrorData] = useState('');
    useEffect(() => setTextValue(value ?? ''), [value]);

    const onChange = (id: string, e: any, country, formattedNumber) => {
        const number = `+${e}`;
        setTextValue(number);
        const phoneValid = parsePhoneNumber(number);
        if (phoneValid?.isValid()) {
            if (!valid) {
                setValid(true);
            }
            onCompChange && onCompChange(id, number);
        } else {
            if (valid) {
                setValid(false);
            }
        }
    };
    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel fontScale={fontScale} color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
         console.log("Asir errorData",errorData);
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        if (!valid) {
            console.log("Asir error message",);
            return (
                <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {`Phone number should contain atleast ${errorData} numbers`}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    document.getElementById(`input-${id}`)?.addEventListener('focusin', (e) => {
        console.log(e, 'moi->');
        document
            .getElementById(`input-group-${id}`)
            ?.classList.add('input-group-ch');
    });
    document
        .getElementById(`input-${id}`)
        ?.addEventListener('focusout', (e) => {
            console.log(e, 'moi->');
            document
                .getElementById(`input-group-${id}`)
                ?.classList.remove('input-group-ch');
        });
        //console.log("Asir input",format);
    return (
        <>
            <Form.Group id={id} className=" formgroup">
                {_renderLabelIf()}
                <InputGroup id={`input-group-${id}`} className="input-group-bt">
                    <PhoneInput
                        className="formcontrol shadow-none"
                        onChange={onChange.bind(null, id)}
                        id={`input-${id}`}
                        required={required}
                        fontScale={fontScale}
                        value={textValue}
                        placeholder={placeholder}
                        enableSearch={true}
                        copyNumbersOnly={false}
                        countryCodeEditable={false}
                        setErrorData={setErrorData}
                    />
                </InputGroup>
                <InputGroup>{_renderErrorTextIf()}</InputGroup>
            </Form.Group>
        </>
    );
};

PhoneNumberInput.defaultProps = {
    required: false,
    hasError: false,
};
